import { render, staticRenderFns } from "./PersonVehiclesTable.vue?vue&type=template&id=bf2533b8&scoped=true&"
import script from "./PersonVehiclesTable.vue?vue&type=script&lang=js&"
export * from "./PersonVehiclesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2533b8",
  null
  
)

export default component.exports